import Immutable from 'immutable';
import { SET_MOLPAY_RESPONSE } from './actions';

const initialState = Immutable.fromJS({
  molpayResponse: null,
});

/**
 * @param {object} state
 * @param {object} action
 * @returns {object} state
 */
export function MOLPayResponse(state = initialState, action = {}) {
  switch (action.type) {
    case SET_MOLPAY_RESPONSE: {
      const { molpayResponse } = action;
      return state.set('molpayResponse', Immutable.fromJS(molpayResponse));
    }
    default: {
      return state;
    }
  }
}
